import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/footer";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import icons from "../../icons.config";
import FooterDoodles from "../Footer/footerDoodles";
import { verifyOtpApi } from "../../Providers/authProvider";

function GetOtp() {
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const email_id = location.state?.email || ""; // Use email instead of mobile

  // Email validation regex
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validate email format
    if (!email_id) {
      setError("Email is required.");
      return;
    }

    if (!validateEmail(email_id)) {
      setError("Invalid email format.");
      return;
    }

    // Validate OTP
    if (!otp || otp.length !== 6) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }

    // Validate password
    if (!password || password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    // Validate confirm password
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      const data = await verifyOtpApi(email_id, otp, password); // Pass email_id
      console.log("OTP Verification Response:", data);

      navigate("/login", { state: { email_id } }); // Pass email_id to login page
    } catch (errMsg) {
      setError(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="w-full flex items-center py-16 relative top-16 lg:top-20 justify-center bg-tertiary overflow-x-hidden">
        <div className="absolute -right-52 -top-12 lg:-right-32 lg:-top-16 z-40">
          <img src={icons.trendCircles} alt="Doodle Left" className="w-[50%] lg:w-[70%]" />
        </div>
        <div className="hidden lg:block absolute left-12 top-20 z-10">
          <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-[75%]" />
        </div>

        <div className="w-full max-w-lg bg-tertiary py-6 px-24 z-30">
          <h2 className="text-center text-2xl font-outfit font-light text-primary1 mb-12">
            SIGN UP
          </h2>

          <form className="space-y-6" onSubmit={handleOtpSubmit}>
            {/* Display Email (read-only) */}
            <div className="relative">
              <label htmlFor="email" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-base font-medium pointer-events-none transform -translate-y-4 scale-75 top-1 z-10 origin-[0]">
                EMAIL ADDRESS
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email_id}
                readOnly
                className="w-full px-4 py-2 border rounded-md text-xs bg-gray-100 text-primary1 font-poppins focus:outline-none placeholder:text-secondary"
              />
            </div>

            {/* OTP Input */}
            <div className="relative">
              <label htmlFor="otp" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-base font-medium pointer-events-none transform -translate-y-4 scale-75 top-1 z-10 origin-[0]">
                ENTER OTP
              </label>
              <input
                type="text"
                id="otp"
                name="otp"
                maxLength="6"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP"
                className="w-full px-4 py-2 border rounded-md text-xs bg-tertiary text-primary1 font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary placeholder:text-secondary"
              />
            </div>

            <p className="text-xs text-left font-outfit">
              *We’ve sent an OTP to your email address. Please enter the OTP to verify your email.
            </p>

            {/* Password Input */}
            <div className="relative">
              <label htmlFor="password" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-base font-medium transform -translate-y-4 scale-75 top-1 z-10">
                PASSWORD
              </label>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="w-full px-4 py-2 border text-xs rounded-md bg-tertiary text-primary1 font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary placeholder:text-secondary"
              />
              <div className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash className="text-secondary opacity-100" /> : <FaEye className="text-secondary opacity-100" />}
              </div>
            </div>

            {/* Confirm Password Input */}
            <div className="relative">
              <label htmlFor="confirmPassword" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-base font-medium transform -translate-y-4 scale-75 top-1 z-10">
                CONFIRM PASSWORD
              </label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="confirmPassword"
                name="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm your password"
                className="w-full px-4 py-2 border text-xs rounded-md bg-tertiary text-primary1 font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary placeholder:text-secondary"
              />
              <div className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? <FaEyeSlash className="text-secondary opacity-100" /> : <FaEye className="text-secondary opacity-100" />}
              </div>
            </div>

            {/* Error Message */}
            {error && <p className="text-red-500 text-sm">{error}</p>}

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-hcolor text-tertiary px-4 py-2 text-sm font-outfit font-light hover:bg-tertiary hover:text-hcolor hover:border-2 hover:border-hcolor focus:outline-none focus:ring-2 focus:ring-primary1 my-2"
              disabled={loading}
            >
              {loading ? "Verifying..." : "VERIFY OTP"}
            </button>
          </form>
        </div>
      </div>
      <FooterDoodles />
      <Footer />
    </>
  );
}

export default GetOtp;










// import React, { useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import Navbar from "../Navbar/navbar";
// import Footer from "../Footer/footer";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import icons from "../../icons.config";
// import FooterDoodles from "../Footer/footerDoodles";
// import { verifyOtpApi } from "../../Providers/authProvider"; // Import the API function

// function GetOtp() {
//   const [otp, setOtp] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const mobile_number = location.state?.mobile || "";

//   const handleOtpSubmit = async (e) => {
//     e.preventDefault();
//     setError("");

//     if (!otp || otp.length !== 6) {
//       setError("Please enter a valid 6-digit OTP.");
//       return;
//     }
//     if (!password || password.length < 6) {
//       setError("Password must be at least 6 characters.");
//       return;
//     }
//     if (password !== confirmPassword) {
//       setError("Passwords do not match.");
//       return;
//     }

//     setLoading(true);

//     try {
//       const data = await verifyOtpApi(mobile_number, otp, password);
//       console.log("OTP Verification Response:", data);

//       navigate("/login", { state: { mobile_number } });
//     } catch (errMsg) {
//       setError(errMsg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="w-full flex items-center py-16 relative top-16 lg:top-20 justify-center bg-tertiary overflow-x-hidden">
//         <div className="absolute -right-52 -top-12 lg:-right-32 lg:-top-16 z-40">
//           <img src={icons.trendCircles} alt="Doodle Left" className="w-[50%] lg:w-[70%]" />
//         </div>
//         <div className="hidden lg:block absolute left-12 top-20 z-10">
//           <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-[75%]" />
//         </div>

//         <div className="w-full max-w-lg bg-tertiary py-6 px-24 z-30">
//           <h2 className="text-center text-2xl font-outfit font-light text-primary1 mb-12">
//             SIGN UP
//           </h2>

//           <form className="space-y-6" onSubmit={handleOtpSubmit}>
//             {/* OTP Input */}
//             <div className="relative">
//               <label htmlFor="otp" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-base font-medium pointer-events-none transform -translate-y-4 scale-75 top-1 z-10 origin-[0]">
//                 ENTER OTP
//               </label>
//               <input
//                 type="text"
//                 id="otp"
//                 name="otp"
//                 maxLength="6"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//                 placeholder="Enter OTP"
//                 className="w-full px-4 py-2 border rounded-md text-xs bg-tertiary text-primary1 font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary placeholder:text-secondary"
//               />
//             </div>

//             <p className="text-xs text-left font-outfit">
//               *We’ve sent an OTP to your mobile number. Please enter the OTP to verify your phone number.
//             </p>

//             {/* Password Input */}
//             <div className="relative">
//               <label htmlFor="password" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-base font-medium transform -translate-y-4 scale-75 top-1 z-10">
//                 PASSWORD
//               </label>
//               <input
//                 type={showPassword ? "text" : "password"}
//                 id="password"
//                 name="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 placeholder="Enter your password"
//                 className="w-full px-4 py-2 border text-xs rounded-md bg-tertiary text-primary1 font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary placeholder:text-secondary"
//               />
//               <div className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
//                 {showPassword ? <FaEyeSlash className="text-secondary opacity-100" /> : <FaEye className="text-secondary opacity-100" />}
//               </div>
//             </div>

//             {/* Confirm Password Input */}
//             <div className="relative">
//               <label htmlFor="confirmPassword" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-base font-medium transform -translate-y-4 scale-75 top-1 z-10">
//                 CONFIRM PASSWORD
//               </label>
//               <input
//                 type={showConfirmPassword ? "text" : "password"}
//                 id="confirmPassword"
//                 name="confirmPassword"
//                 value={confirmPassword}
//                 onChange={(e) => setConfirmPassword(e.target.value)}
//                 placeholder="Confirm your password"
//                 className="w-full px-4 py-2 border text-xs rounded-md bg-tertiary text-primary1 font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary placeholder:text-secondary"
//               />
//               <div className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
//                 {showConfirmPassword ? <FaEyeSlash className="text-secondary opacity-100" /> : <FaEye className="text-secondary opacity-100" />}
//               </div>
//             </div>

//             {/* Error Message */}
//             {error && <p className="text-red-500 text-sm">{error}</p>}

//             {/* Submit Button */}
//             <button type="submit" className="w-full bg-hcolor text-tertiary px-4 py-2 text-sm font-outfit font-light hover:bg-tertiary hover:text-hcolor hover:border-2 hover:border-hcolor focus:outline-none focus:ring-2 focus:ring-primary1 my-2" disabled={loading}>
//               {loading ? "Verifying..." : "VERIFY OTP"}
//             </button>
//           </form>
//         </div>
//       </div>
//       <FooterDoodles />
//       <Footer />
//     </>
//   );
// }

// export default GetOtp;

